module.exports = __webpack_public_path__ + "img/pin.87306d63.svg";